const DEFAULT_TRANSFER_VALUE_INDEX = "0";
const DEFAULT_TRANSFER_VALUES =
  "<$25k, $25k to $100k, $100k to $500k, $500k to $1m, >$1m";

/**
 *
 * @returns  {{
 *  transferValueIndex: number,
 *  configuredTransferValues: string,
 *  alwaysShowDetailForm: boolean,
 *  fromCurrency: string,
 *  toCurrency: string,
 *  referralCode: string,
 *  showDetailFormMinimumValue: string,
 *  slider: boolean
 * }} config
 */
const getConfig = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const affiliateId = urlParams.get("affiliateId");
  const trackingId = urlParams.get("trackingId");
  const transferValueIndexString =
    urlParams.get("defaultValue") || DEFAULT_TRANSFER_VALUE_INDEX;
  const transferValueIndex = parseInt(transferValueIndexString);
  const configuredTransferValuesString =
    urlParams.get("configuredTransferValues") || DEFAULT_TRANSFER_VALUES;
  const configuredTransferValues = configuredTransferValuesString.split(", ");
  const alwaysShowDetailForm = urlParams.get("alwaysShowDetailForm") === "true";
  const fromCurrency = urlParams.get("fromCurrency") || "AUD";
  const toCurrency = urlParams.get("toCurrency") || "NZD";
  const referralCode = urlParams.get("referral") || "";
  const showDetailFormMinimumValue =
    urlParams.get("showDetailFormMinimumValue") || "$25k to $100k";
  const slider = urlParams.get("slider") !== "false";
  const utmTerm = urlParams.get("utm_term") || "";

  return {
    affiliateId,
    trackingId,
    transferValueIndex,
    configuredTransferValues,
    alwaysShowDetailForm,
    fromCurrency,
    toCurrency,
    referralCode,
    showDetailFormMinimumValue,
    slider,
    metadata: JSON.stringify({
      utmTerm,
    }),
  };
};

export default getConfig;
